import { render, staticRenderFns } from "./apps-roles.vue?vue&type=template&id=af20e104"
import script from "./apps-roles.vue?vue&type=script&lang=js"
export * from "./apps-roles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports